import { Controller } from '@hotwired/stimulus'

export default class PasswordVisibility extends Controller {
  static targets = ['input', 'revealIcon', 'hideIcon']

  toggle() {
    if (this.#isPasswordHidden()) this.#revealPassword()
    else this.#hidePassword()
  }

  #isPasswordHidden() {
    return this.hasInputTarget && this.inputTarget.type === 'password'
  }

  #revealPassword() {
    if (this.hasInputTarget) this.inputTarget.type = 'text'

    if (this.hasRevealIconTarget && this.hasHideIconTarget) {
      this.revealIconTarget.classList.toggle('hidden', true)
      this.hideIconTarget.classList.toggle('hidden', false)
    }
  }

  #hidePassword() {
    if (this.hasInputTarget) this.inputTarget.type = 'password'

    if (this.hasRevealIconTarget && this.hasHideIconTarget) {
      this.revealIconTarget.classList.toggle('hidden', false)
      this.hideIconTarget.classList.toggle('hidden', true)
    }
  }
}
